import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container">
      <Weather defaultCity="Montevideo" />

      </div>
    </div>
  );
}

